export function* vehicleStatusesSaga() {}
